import React from "react";
import Loadable from "../../react-loadable";

const WeaSelectGroup = Loadable({
  loader: () => import("./SelectGroup"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaSelectGroup;



// WEBPACK FOOTER //
// ./ecology9/wea-select-group/index.js